import * as React from 'react';
import { ArticleHeading2, ArticleParagraph1, Image } from '@cian/ui-kit';

import * as styles from './PromoDescription.css';

import { IPromoProp } from '../../../../types/specialPromos/promoProp';
import { PromoFeatures } from '../PromoFeatures';

interface IPromoDescriptionProps {
  description?: string | null;
  features: IPromoProp[];
  logo: string;
  promoName: string;
  providerName: string;
}

export const PromoDescription: React.FC<IPromoDescriptionProps> = ({
  description,
  features,
  logo,
  promoName,
  providerName,
}) => {
  return (
    <>
      <div className={styles['header']}>
        <div className={styles['title']}>
          <ArticleHeading2 as="h2">{promoName}</ArticleHeading2>
          {providerName && (
            <div className={styles['provider']}>
              <ArticleParagraph1>{providerName}</ArticleParagraph1>
            </div>
          )}
        </div>
        <div className={styles['logo']}>
          <Image src={logo} borderRadius="0" objectFit="contain" />
        </div>
      </div>
      {features.length > 0 && (
        <div className={styles['features-list']}>
          <PromoFeatures features={features} />
        </div>
      )}
      {description && <p className={styles['description']}>{description}</p>}
    </>
  );
};
